import { createSelector } from 'reselect';

export const getActivePromotion = (state: any) => state.promotion;

export const hasPromotion = createSelector(
  getActivePromotion,
  activePromotion => Boolean(activePromotion)
);

export const getPromotionServices = createSelector(
  getActivePromotion,
  activePromotion => (activePromotion ? activePromotion.services : null)
);

export const getPromoStartTime = createSelector(
  getActivePromotion,
  activePromotion => (activePromotion ? activePromotion.apptStartTime : null)
);

export const getPromoEndTime = createSelector(
  getActivePromotion,
  activePromotion => (activePromotion ? activePromotion.apptEndTime : null)
);

export const getPromoDaysOfWeekArray = createSelector(
  getActivePromotion,
  activePromotion =>
    activePromotion ? activePromotion.daysOfWeek.split('') : false
);

export const getPromotionStartDate = createSelector(
  getActivePromotion,
  activePromotion => (activePromotion ? activePromotion.apptStartDate : null)
);

export const getPromotionEndDate = createSelector(
  getActivePromotion,
  activePromotion => (activePromotion ? activePromotion.apptEndDate : null)
);

export const getPromotionType = createSelector(
  getActivePromotion,
  activePromotion => (activePromotion ? activePromotion.promoType : null)
);

export const getPromotionGroupByType = createSelector(
  getPromotionType,
  promoType => {
    if (promoType) {
      switch (promoType) {
        case 'declinedServiceCurrencyDiscount':
        case 'declinedServicePercentDiscount':
          return 'declined';
        default:
          return 'service';
      }
    }
    return null;
  }
);

export const getPromotionDiscountAmt = createSelector(
  getActivePromotion,
  activePromotion => (activePromotion ? activePromotion.promoDiscountAmt : null)
);

export const getPromotionDescription = createSelector(
  getActivePromotion,
  activePromotion =>
    activePromotion ? activePromotion.promotionDescription : null
);

export const getDefaultPromotionFlag = (state: any) => true;



// WEBPACK FOOTER //
// ./src/store/reducers/promotions/selectors.js